import { _request,APIBaseResponse, APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const USER_GROUP_PATH_PREFIX = 'usergroupmemberships';

type APIUserGroupUserMembershipListParams = RequestParamsBase & {
    tenantId: string;
    userId: string;
};

type APIUserGroupUserMembershipListResponse = APIBaseResponse<Array<{
    userGroupId: string;
    userId: string;
    userGroup: {
        id: string;
        name:string;
        description:string;
        tenantId:string;
    }
}>>;

type APIUserGroupUserMembershipDeleteParams = {
    tenantId: string;
    userId: string;
    userGroupId: string;
};

type APIUserGroupUserMembershipDeleteResponse = APIBaseResponse<''>;

export type APIUserGroupUserMembershipPostParams = {
    tenantId: string;
    userGroupId: string;
    userId: string;
}

export type APIUserGroupUserMembershipPostResponse = APIBaseResponse;

export const APIUserGroupUserMembershipGetList: APIMethod<APIUserGroupUserMembershipListParams, APIUserGroupUserMembershipListResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}?userId=${params.userId}`, undefined, params.signal)
);

export const APIUserGroupUserMembershipDelete: APIMethod<APIUserGroupUserMembershipDeleteParams, APIUserGroupUserMembershipDeleteResponse> = params => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}?userId=${params.userId}&usergroupId=${params.userGroupId}`)
);

export const APIUserGroupUserMembershipPost: APIMethod<APIUserGroupUserMembershipPostParams, APIUserGroupUserMembershipPostResponse> = params => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}`, params)
);
